import loadable from '@loadable/component';
import React from 'react';
import { ThemeProvider } from 'styled-components';

import { RouteGuard } from '../src/components/RouteGuard';
import { VLibras } from '../src/components/shared/VLibras';
import { AuthContextProvider } from '../src/contexts/AuthContext';
import { ProfileContextProvider } from '../src/contexts/ProfileContext';
import GlobalStyle from '../src/styles/global';
import theme from '../src/styles/theme';

const Layout = loadable(() => import('../src/pages/layout'));

//@ts-expect-error unknow type
export function wrapRootElement({ element, props }) {
  return (
    <AuthContextProvider location={props?.location}>
      <ProfileContextProvider>
        <ThemeProvider theme={theme}>
          <Layout>
            <GlobalStyle />
            <VLibras />
            <RouteGuard>{element}</RouteGuard>
          </Layout>
        </ThemeProvider>
      </ProfileContextProvider>
    </AuthContextProvider>
  );
}
